import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Support from './pages/Support';

function App() {
  // CRA: `homepage` or `PUBLIC_URL` controls where the app is hosted (e.g. /hexasnake).
  // This makes routes like /hexasnake/support work in production.
  const basename = process.env.PUBLIC_URL || '';
  return (
    <Router basename={basename}>
      <div className="App">
        <header className="App-header">
          <div className="header-content">
            <h1 className="app-title">🔷 六边形贪吃蛇</h1>
            <nav className="nav-menu">
              <Link to="/" className="nav-link">首页</Link>
              <Link to="/support" className="nav-link">技术支持</Link>
              <Link to="/privacy" className="nav-link">隐私政策</Link>
            </nav>
          </div>
        </header>
        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </main>
        
        <footer className="App-footer">
          <p>© 2026 HexaSnake Hive. All rights reserved.</p>
          <p className="footer-links">
            <Link to="/privacy">隐私政策</Link>
            <span className="separator">|</span>
            <Link to="/support">技术支持</Link>
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
